import { render } from "./AppSkeyndor.vue?vue&type=template&id=31913ed3&scoped=true"
import script from "./AppSkeyndor.vue?vue&type=script&lang=js"
export * from "./AppSkeyndor.vue?vue&type=script&lang=js"

import "./AppSkeyndor.vue?vue&type=style&index=0&id=31913ed3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\petr.hric\\Desktop\\MyDrive\\web\\mkosmeo\\mkosmeo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31913ed3"]])

export default __exports__